import { useSidebarStore } from "@/stores/useSidebarStore";
import { useMediaQuery } from "@mantine/hooks";
import { useNavigate } from "react-router";
import { navigateFromSidebar } from "./sidebarNavigation";

export function useSidebarNavigate() {
  const isMobile = useMediaQuery("(max-width: 768px)") || false;
  const toggleSidebar = useSidebarStore((state) => state.toggle);
  const navigate = useNavigate();

  return function navigateTo(link: string) {
    navigateFromSidebar({
      isMobile,
      closeSidebar: () => toggleSidebar(false),
      navigate: () => navigate(link),
    });
  };
}
